<template lang="pug">
div(id="pix-success-page" class="pageSuccess")
    YboxIframe(v-if="isPaid" :amount="`${planSelect.totalValue}`" :uuid="`${planSelect.uuid}`")
    div.success-page__header
      img(:src="iconSvg('icon-success-purple')" alt="Sucesso!")
      h2 {{ headerTitle }}
      p(v-html="headerText")

    div.success-page__content
      div(v-if="!isPaid" class="success-page__block")
        div.success-page__block__column
          p QR code expira em #[strong 24 horas] #[br] #[span Gerado em {{ qrCodeGenerationDate }}]
          img(:src="payment.url" alt="Pix QR Code")

          div.success-page__block__column--footer
            cp-button(
              label="Copiar código Pix"
              theme="purple-filled"
              @click.prevent.stop="clickToCopy(payment.qrCodeTextImage, 'pixCode')"
            )

        div.success-page__block__column
          ul
            li 1. Abra o app da sua instituição financeira ou banco;
            li 2. Na área de Pix, leia o QR code ou copie e cole o código;
            li 3. Revise as informações e confirme;
            li 4. Assim que o pagamento aprovar a tela irá atualizar seu pedido aprovado.

          p #[strong Atenção:] Nós também te enviamos um email com validade de 24 horas para pagamento, caso não encontre, verifique a caixa de ”spam”.

          div.success-page__block__column--info
            strong O Pagamento ja foi confirmado?
            a(
              v-if="!loadingPixPaymentStatus"
              href=""
              @click.prevent.stop="checkPayment(true)"
            ) Clique aqui
            img(v-else :src="iconSvg('loader-dark')" alt="Carregando..")

      NPS(:name="voucherRecipient.name" :email="voucherRecipient.email")

      div.success-page__block
        h3 Resumo da compra

        template(v-if="promoCode.valid")
          div.success-page__block__row
            p #[span Subtotal:] #[strong {{ olderTotalValue | currency }}]

          div.success-page__block__row.row-discount
            p #[span Desconto:] #[strong - {{ (olderTotalValue - payment.amount).toFixed(2) | currency }}]

        div.success-page__block__row(:class="{ 'row-footer': promoCode.valid}")
          p #[span Valor Total:] #[strong {{ payment.amount | currency }}]

      div.success-page__block
        span.icon.icon__pix Pagamento via Pix

      div.success-page__block
        div.success-page__accordion
          div.success-page__accordion-head
            div.success-page__accordion-head-title
              img(:src="iconSvg('icon-location-purple')" alt="Destino")
              span {{ destinationLabel }}

            button(
              v-if="isDesktop"
              @click.prevent.stop="toggleDetails"
              :class="{'opened': showDetails}"
            )
              span Ver detalhes

          div.success-page__accordion-content(v-if="showDetails")
            div.success-page__accordion-content-row
              img(:src="iconSvg('icon-passengers-purple')" alt="Passageiros")
              p #[strong Passageiros: ] #[span(v-html="inputedAgePassengers")]

            div.success-page__accordion-content-row
              img(:src="iconSvg('icon-coverage-purple')" alt="Cobertura")
              p #[strong Cobertura: ] #[span {{ planSelect.packageLabel }} / pessoa]

            div.success-page__accordion-content-row
              img(:src="iconSvg('icon-calendar-purple')" alt="Vigência")
              p #[strong Vigência: ] #[span {{ initialDate | date8601 }} ~ {{ endDate | date8601 }}]

            div.success-page__accordion-content-row(v-if="planSelect.liveloPoints")
              img(:src="iconSvg('icon-livelo-purple')" alt="pontos Livelo")
              p #[strong {{ planSelect.liveloPoints }} pontos Livelo]

            div.success-page__accordion-content-row(v-if="planSelect.includeChip")
              img(:src="iconSvg('sim-card')" alt="Chip digital eSim")
              p #[strong 1 Chip digital eSIM]

      div.ciclicCellphoneCTA
        CellphoneCTA

      div.success-page__footer
        cp-button(
          label="Continuar navegando"
          icon="chevron-left"
          theme="link"
          @click="$router.push('/')"
        )

    div.ciclicCellphoneModal
      CellphoneModal
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { date8601, document, currency, points } from '@/filters'
import { checkPixPayment } from '@/api/services.js'

import cpButton from '@/components/ui/Button'
import moment from 'moment'

import YboxIframe from '../YboxIframe/index.vue'
import NPS from '@/components/NPS.vue'
import CellphoneCTA from '@/components/CellphoneCTA.vue'
import CellphoneModal from '@/components/CellphoneModal.vue'

export default {
  name: 'Pix',
  components: {
    cpButton,
    YboxIframe,
    NPS,
    CellphoneCTA,
    CellphoneModal
  },
  data () {
    return {
      showDetails: false,
      isDesktop: true,
      isPaid: false,
      loadingPixPaymentStatus: false,
      timer: ''
    }
  },
  filters: {
    currency,
    date8601,
    document,
    points
  },
  computed: {
    ...mapState('travelSetup', ['theme']),
    ...mapGetters('quotation', ['selectedCovidCovers']),
    ...mapState(['payment']),
    ...mapState('quotation', [
      'initialDate',
      'endDate',
      'result',
      'numberOfPassengersFourtyYears',
      'numberOfPassengersSixtyFourYears',
      'numberOfPassengersSeventyFiveYears',
      'numberOfPassengersEightyFiveYears',
      'numberOfPassengersNinetyNineYears',
      'selectedQuote',
      'destinationId',
      'countriesSelected',
      'promoCode'
    ]),
    ...mapState('user', ['voucherRecipient']),
    ...mapState('additional', ['pcr']),
    planSelect () {
      return this.result[this.selectedQuote]
    },
    headerTitle () {
      return this.isPaid
        ? 'Seu pagamento foi aprovado com sucesso'
        : 'Seu pedido foi confirmado com sucesso'
    },
    headerText () {
      if (this.planSelect.includeChip) {
        return this.isPaid
          ? `Compra realizada com sucesso. Em breve você receberá dois e-mails diferentes: um para fazer download da apólice e outro com o passo a passo para ativação do seu chip eSIM. Confira sua caixa de entrada `
          : `Segue abaixo as instruções para pagamento e confirmação de compra. Assim que confirmado, enviaremos para o e-mail <strong>${this.emailString}</strong> dois e-mails diferentes: um para fazer download da apólice e outro com o passo a passo para ativação do seu chip eSIM.`
      }

      return this.isPaid
        ? `A apólice será enviada para o e-mail: <strong>${this.emailString}</strong>`
        : `Segue abaixo as instruções para pagamento e confirmação da sua compra. Assim que confirmado, você receberá os detalhes do serviço contratado no email <strong>${this.emailString}</strong>.`
    },
    emailString () {
      return this.payment.email || 'o e-mail de cadastro '
    },
    qrCodeGenerationDate () {
      return moment(this.payment.createdDateBR).format('DD/MM/YYYY - HH[h]mm')
    },
    olderTotalValue () {
      const key = Object.keys(this.result).find(uuid => uuid === this.selectedQuote)

      return this.result[key].olderTotalValue
    },
    destinationLabel () {
      return /Y(30|15)/.test(this.destinationId)
        ? `Multi Trip ${this.destinationId.slice(-2)}`
        : this.formatCountriesLabel()
    },
    inputedAgePassengers () {
      const passengers = [
        {
          checked: this.numberOfPassengersFourtyYears,
          returnString: `<strong>${this.numberOfPassengersFourtyYears}</strong> até 40 anos`
        }, {
          checked: this.numberOfPassengersSixtyFourYears,
          returnString: `<strong>${this.numberOfPassengersSixtyFourYears}</strong> de 41 a 64 anos`
        }, {
          checked: this.numberOfPassengersSeventyFiveYears,
          returnString: `<strong>${this.numberOfPassengersSeventyFiveYears}</strong> de 65 a 75 anos`
        }, {
          checked: this.numberOfPassengersEightyFiveYears,
          returnString: `<strong>${this.numberOfPassengersEightyFiveYears}</strong> de 76 a 85 anos`
        }, {
          checked: this.numberOfPassengersNinetyNineYears,
          returnString: `<strong>${this.numberOfPassengersNinetyNineYears}</strong> de 86 a 99 anos`
        }
      ]

      return passengers.filter(obj => obj.checked).map(({ returnString }) => returnString).join(' - ')
    },
    showChipBanner () {
      return (this.destinationId !== 'BR')
    }
  },
  created () {
    this.timer = setInterval(this.checkPayment, 60000)
  },
  mounted () {
    const windowSize = window.innerWidth

    if (windowSize <= 768) {
      this.isDesktop = false
      this.showDetails = true
    }
  },
  beforeDestroy () {
    this.cancelAutoCheckForPayment()
  },
  methods: {
    iconSvg (image) {
      return require(`@/assets/icons/${image}.svg`)
    },
    quotationDetails () {
      this.openQuotationDetails = !this.openQuotationDetails
    },
    formatCountriesLabel () {
      const countriesSelected = this.countriesSelected.map(({ label }) => label)

      if (!countriesSelected) return false
      if (countriesSelected.length === 1) return `${countriesSelected[0]}`
      if (countriesSelected.length <= 3) {
        return `${countriesSelected.slice(0, -1).join(', ')} e ${countriesSelected.slice(-1)}`
      }

      return `${countriesSelected[0]}, ${countriesSelected[1]}, ${countriesSelected[2]} e mais ${countriesSelected.length - 3} ${countriesSelected.length === 4 ? 'país' : 'países'}`
    },
    clickToCopy (text, action) {
      const actions = {
        pixCode: ' O código do Pix foi copiado para sua área de transferência.'
      }

      this.showToast('success', actions[action])
      return navigator.clipboard.writeText(text)
    },
    toggleDetails () {
      this.showDetails = !this.showDetails
    },
    showToast (icon, msg) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', this.$swal.stopTimer)
          toast.addEventListener('mouseleave', this.$swal.resumeTimer)
        }
      })

      Toast.fire({ icon, title: msg })
    },
    async checkPayment (isManual = false) {
      this.loadingPixPaymentStatus = true

      return checkPixPayment(this.payment.uuid)
        .then((response) => {
          if (response.status === 'PAID') {
            this.isPaid = true
            this.cancelAutoCheckForPayment()
            this.showToast('success', 'Pagamento identificado com sucesso.')
          } else if (response.status === 'EXPIRED') {
            console.warn('VENCIDO')
          } else {
            if (isManual) {
              this.showToast('warning', 'Pagamento ainda não identificado. Aguarde alguns minutos e tente novamente.')
            }
          }
        })
        .catch((e) => console.error('<<< Error fetching pix payment status: ', e))
        .finally(() => {
          this.loadingPixPaymentStatus = false
        })
    },
    cancelAutoCheckForPayment () {
      return clearInterval(this.timer)
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

#pix-success-page {
  align-items: center;
  display: flex;
  flex-direction: column;

  .success-page__header {
    max-width: 752px;
    text-align: center;
    padding-top:32px;
    width: 100%;

    img {
      margin-bottom: 12px;
    }
  }

  .success-page__content {
    max-width: 944px;
    width: 100%;

    .success-page__block {
      align-items: center;
      flex-shrink: 0;
      flex-wrap: wrap;
      justify-content: flex-end;

      span {
        margin-right: auto;
      }

      button {
        width: 100%;

        @media (min-width: 768px) {
          width: fit-content;
        }
      }

      &__column {
        &:nth-child(1) {
          text-align: center;
          width: 100%;

          @media (min-width: 768px) {
            width: 40%;
          }

          p {
            color: #707070;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            text-align: center;

            span {
              color: #979797;
              display:block;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 17px;
              margin-top: 8px;
            }

            strong {
              color: #444444;
              font-style: normal;
              font-size: 14px;
              line-height: 17px;
            }
          }

          img {
            border-radius: 8px;
            border: 0.8px solid #F4F4F4;
          }

          .success-page__block__column--footer {
            border-bottom: 1px solid #C8C8C8;
            display: flex;
            align-items: center;
            margin-top: 14px;
            margin-bottom: 24px;
            padding: 0 13% 24px;

            @media (min-width: 768px) {
              border-bottom: none;
              flex-direction: row;
              margin-bottom: 0;
              padding: 0 10px;
            }

            @media (min-width: 997px) {
              padding: 0 13%;
            }
          }
        }

        &:nth-child(2) {
          color: #707070;
          margin-bottom: auto;
          width: 100%;

          @media (min-width: 768px) {
            padding: 0 0 0 50px;
            width: 60%;
          }

          @media (min-width: 997px) {
            padding: 0;
          }

          ul {
            list-style: none;

            li {
              margin-bottom: 38px;
            }
          }

          p {
            margin: 4px 0 28px;
          }

          .success-page__block__column--info {
            background-color: #F4F4F4;
            display: flex;
            padding: 16px;
            width: 100%;

            strong {
              color: #595959;
              font-style: normal;
              font-size: 16px;
              line-height: 22px;
              margin-right: 14px;
            }

            a {
              color: #6320E9;
              font-style: normal;
              font-weight: normal;
              font-size: 16px;
              line-height: 24px;
            }

            img {
              width: 20px;
            }
          }
        }
      }

      &__row {
        flex-shrink: 0;
        flex-wrap: wrap;

        &.row-discount {
          margin-top: 12px;
        }

        p {
          display: flex;
          margin: 0;
          width: 100%;

          + p {
            margin-top: 12px;
          }

          span {
            color: #444444;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
          }

          strong {
            color: #444444;
            font-style: normal;
            font-size: 16px;
            line-height: 19px;
            margin-left: auto;
            text-align: right;
          }
        }
      }

      .success-page__accordion {
        width: 100%;

        &-head {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          &-title {
            align-items: center;
            display: flex;
            justify-content: flex-start;

            img {
              margin-right: 16px;
              width: 32px;
            }

            span {
              color: #444444;
              font-family: $oscine-font-family, sans-serif;
              font-style: normal;
              font-weight: bold;
              font-size: 18px;
              line-height: 23px;
            }
          }

          button {
            &.opened {
              span {
                &::before {
                  transform: rotate(0);
                  transition: all ease 0.2s;
                }
              }
            }

            &:focus {
              outline:0;
            }

            span {
              display: inline-block;
              padding-right: 20px;
              position: relative;

              &::before {
                background-image: url(~@/assets/icons/chevron-up.svg);
                content: '';
                height: 7px;
                position: absolute;
                right: 0;
                top: calc(50% - 3.5px);
                transform: rotate(180deg);
                transition: all ease 0.2s;
                width: 14px;
              }
            }
          }
        }

        &-content {
          margin-top: 22px;

          &-row {
            align-items: center;
            border-top: solid 1px #BDC2C6;
            display: flex;
            padding: 20px 0;
            justify-content: flex-start;
            text-align: left;

            &:last-child {
              padding-bottom: 0;
            }

            img {
              margin-right: 16px;
              width: 32px;
            }

            p {
              margin: 0;

              span {
                color: #444444;
                font-family: $oscine-font-family, sans-serif;
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 21px;
              }

              strong {
                color: #444444;
                font-family: $oscine-font-family, sans-serif;
                font-style: normal;
                font-size: 16px;
                line-height: 21px;
              }
            }
          }
        }
      }
    }

    .ciclicCellphoneCTA {
      margin: 16px auto;
    }

    .success-page__footer {
      align-items: center;
      display: flex;
      justify-content: center;
      padding: 30px 0;
    }
  }
}
</style>
